<template>
    <BreezeAuthenticatedLayout>
        <div class="flex flex-wrap mt-[15px] mb-[8px] px-[24px]" v-if="screan === 0">
            <Heading_H1 :type="true">My Projects</Heading_H1>
            <div class="w-full mt-[24px] gap-y-[24px] flex flex-wrap justify-between" >
                <div class="w-full">
                    <Link :href="route('user.projects.view',item.id)" class="w-full" v-for="item in projects" :key="item.name">
                        <panel :text="item.name"/>
                    </Link>
                    <panel @click="screan = 1"  text="View other projects">
                        <template #svg>
                            <svg width="35" height="34" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.59814 7.60158C4.59814 7.60158 13.0555 6.87788 15.9037 10.0655C16.4117 10.6341 16.7385 11.2351 16.9326 11.8388C14.6994 10.5853 10.9885 9.45666 5.28991 9.29313C6.31067 10.0088 7.58144 10.7687 8.88019 11.5453C12.3949 13.6471 16.1144 15.8713 15.6377 17.6718C14.7564 18.3392 11.8512 20.2116 9.44338 18.0073C6.56788 15.375 4.59814 7.60158 4.59814 7.60158Z" fill="#7A9EB8"/>
                                <path d="M21.8302 17.1097C21.8302 17.1097 21.1676 13.8604 23.4537 12.1369C25.7398 10.4134 29.741 12.1362 29.741 12.1362C29.741 12.1362 28.5978 16.1572 26.3115 17.306C24.0251 18.4547 21.8302 17.1097 21.8302 17.1097Z" fill="#7A9EB8"/>
                                <path d="M12.5981 13.9305C18.2942 18.0655 18.6796 21.938 18.1297 29.2892M21.741 17.7702C19.7818 18.7547 18.3124 21.216 18.3124 24.1696M15.9037 10.0655C13.0555 6.87788 4.59814 7.60158 4.59814 7.60158C4.59814 7.60158 6.56788 15.375 9.44338 18.0073C11.8512 20.2116 14.7564 18.3392 15.6377 17.6718C16.1144 15.8713 12.3949 13.6471 8.88019 11.5453C7.58144 10.7687 6.31067 10.0088 5.28991 9.29313C10.9885 9.45666 14.6994 10.5853 16.9326 11.8388C16.7385 11.2351 16.4117 10.6341 15.9037 10.0655ZM23.4537 12.1369C21.1676 13.8604 21.8302 17.1097 21.8302 17.1097C21.8302 17.1097 24.0251 18.4547 26.3115 17.306C28.5978 16.1572 29.741 12.1362 29.741 12.1362C29.741 12.1362 25.7398 10.4134 23.4537 12.1369Z" stroke="#7A9EB8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </template>
                    </panel>
                    <Link :href="route('user.projects.create')" class="w-full" >
                        <panel text="Create a new Project">
                            <template #svg>
                                <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.49731 21.8485C5.49731 21.8485 12.294 21.2669 14.5829 23.8286C14.9912 24.2856 15.2538 24.7685 15.4098 25.2537C13.6151 24.2463 10.6329 23.3393 6.05325 23.2079C6.87357 23.783 7.89482 24.3937 8.93855 25.0178C11.7631 26.7069 14.7523 28.4944 14.3692 29.9413C13.6609 30.4776 11.3262 31.9824 9.39115 30.211C7.08028 28.0955 5.49731 21.8485 5.49731 21.8485Z" fill="#7A9EB8"/>
                                    <path d="M19.3457 29.4896C19.3457 29.4896 18.8132 26.8783 20.6504 25.4932C22.4877 24.1081 25.7032 25.4927 25.7032 25.4927C25.7032 25.4927 24.7845 28.7241 22.9471 29.6473C21.1096 30.5705 19.3457 29.4896 19.3457 29.4896Z" fill="#7A9EB8"/>
                                    <path d="M11.9265 26.9346C16.504 30.2577 16.8138 33.3699 16.3719 39.2776M19.274 30.0204C17.6996 30.8116 16.5187 32.7896 16.5187 35.1633M14.5829 23.8286C12.294 21.2669 5.49731 21.8485 5.49731 21.8485C5.49731 21.8485 7.08028 28.0955 9.39115 30.211C11.3262 31.9824 13.6609 30.4776 14.3692 29.9413C14.7523 28.4944 11.7631 26.7069 8.93855 25.0178C7.89482 24.3937 6.87357 23.783 6.05325 23.2079C10.6329 23.3393 13.6151 24.2463 15.4098 25.2537C15.2538 24.7685 14.9912 24.2856 14.5829 23.8286ZM20.6504 25.4932C18.8132 26.8783 19.3457 29.4896 19.3457 29.4896C19.3457 29.4896 21.1096 30.5705 22.9471 29.6473C24.7845 28.7241 25.7032 25.4927 25.7032 25.4927C25.7032 25.4927 22.4877 24.1081 20.6504 25.4932Z" stroke="#7A9EB8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M29.8705 23.198C35.1724 23.198 39.4705 18.9 39.4705 13.598C39.4705 8.29611 35.1724 3.99805 29.8705 3.99805C24.5686 3.99805 20.2705 8.29611 20.2705 13.598C20.2705 18.9 24.5686 23.198 29.8705 23.198ZM31.0705 9.99805C31.0705 9.3353 30.5332 8.79805 29.8705 8.79805C29.2078 8.79805 28.6705 9.3353 28.6705 9.99805V12.398H26.2705C25.6078 12.398 25.0705 12.9353 25.0705 13.598C25.0705 14.2608 25.6078 14.798 26.2705 14.798H28.6705V17.198C28.6705 17.8608 29.2078 18.398 29.8705 18.398C30.5332 18.398 31.0705 17.8608 31.0705 17.198V14.798H33.4705C34.1332 14.798 34.6705 14.2608 34.6705 13.598C34.6705 12.9353 34.1332 12.398 33.4705 12.398H31.0705V9.99805Z" fill="#00BF8C"/>
                                </svg>
                            </template>
                        </panel>
                    </Link>
                </div>
            </div>

        </div>
        <template v-else>
            <div class="flex flex-wrap mt-[15px] mb-[8px] px-[24px]">
                <div @click="screan = 0" class="w-full flex flex-wrap justify-start items-center ">
                    <svg width="32" height="32" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_2440_1962)">
                            <rect class="fill-[#232F80] dark:fill-[#2F45C5]" x="40.1875" y="40.6123" width="40" height="40" rx="20" transform="rotate(180 40.1875 40.6123)"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M23.0362 26.2608C23.5049 25.7922 23.5049 25.0324 23.0362 24.5638L19.0848 20.6123L23.0362 16.6608C23.5049 16.1922 23.5049 15.4324 23.0362 14.9638C22.5676 14.4951 21.8078 14.4951 21.3392 14.9638L16.5392 19.7638C16.0705 20.2324 16.0705 20.9922 16.5392 21.4608L21.3392 26.2608C21.8078 26.7295 22.5676 26.7295 23.0362 26.2608Z" fill="white"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_2440_1962">
                                <rect width="40" height="40" fill="white" transform="translate(0.1875 0.612305)"/>
                            </clipPath>
                        </defs>
                    </svg>
                    <span class="font-bold montserrat ml-3 uppercase text-t_purple-700 text-[13px] dark:text-white">Back - </span>
                    <span  class=" montserrat ml-3 uppercase text-t_purple-700 text-[13px] dark:text-white">
                        My projects
                    </span>
                </div>
                <div class="w-full mt-[16px]">
                    <span class="text-[24px] mb-[40px] mfont-bold text-t_black-800 dark:text-t_white-200 font-fira font-semibold">
                        Other Projects
                    </span>
                </div>
                <div class="w-full mt-[24px] gap-y-[24px] flex flex-wrap justify-between" >
                    <div class="w-full">
                        <Link :href="route('user.projects.view',item.id)" class="w-full" v-for="item in projects_all" :key="item.name">
                            <panel :text="item.name"/>
                        </Link>
                    </div>
                </div>
            </div>
        </template>
    </BreezeAuthenticatedLayout>
</template>

<script>
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Link } from '@inertiajs/vue3'
import Heading_H1 from "@/UI/Text/Heading_H1.vue";
import TagText from "@/UI/Text/TagText.vue";
import TextVal from "@/Components/Inspection/Other/TextVal.vue";
import ArrowNext from "@/Components/SVG/ArrowNext.vue";
import Panel from "@/Components/Panel.vue"

export default {
    components:{
        Link,
        BreezeAuthenticatedLayout,
        Heading_H1,
        TagText,
        ArrowNext,
        TextVal,
        Panel
    },
    name: "UserProjects",
    props:{
        projects:Object,
        projects_all:Object,
    },
    data() {
        return {
            screan: 0
        }
    },
    mounted() {

    },
    methods: {

    }
}
</script>
<style scoped>

</style>
